import { IS_SERVER } from '../../common/constants';

export type LtpDisplayLanguage = 'en' | 'es';

/**
 * en-US / es-US per product spec: from browser language, not page locale.
 * Spanish: es-US, es-us, or generic `es` (US build); other `es-XX` (e.g. es-MX) use English.
 */
export const getLtpBrowserLanguage = (): LtpDisplayLanguage => {
  if (IS_SERVER || typeof window === 'undefined' || !window.navigator) {
    return 'en';
  }
  const raw = (window.navigator.languages && window.navigator.languages[0]) || window.navigator.language || 'en-US';
  const normalized = raw.toLowerCase().replace(/_/g, '-');
  if (normalized === 'es' || normalized === 'es-us') {
    return 'es';
  }
  if (normalized.startsWith('es-') && normalized !== 'es-us') {
    return 'en';
  }
  return 'en';
};
